import React from "react";
import PropTypes from "prop-types";
import { Image } from "@learningblocks/shared-components";
import "../style.scss";

import MoveIcon from "@common/images/move.svg";

const ENTER_KEY = 13;
/**
 * MoveOption :
 * - MoveOption for HexagonCard
 */
export function MoveOption(props) {
  const onClick = (event) => props.onSelect(event);

  const onKeyDown = (event) =>
    event.keyCode === ENTER_KEY && props.onSelect(event);

  return props.onSelect ? (
    <div
      role="button"
      tabIndex={props.tabIndex}
      onKeyDown={onKeyDown}
      onClick={onClick}
      className="hex_action"
      aria-label="Move node"
    >
      <Image src={MoveIcon} alt="move node" />
    </div>
  ) : null;
}

MoveOption.propTypes = {
  /**
   * Callback for onClick/onKeyDown event
   */
  onSelect: PropTypes.func,
  /**
   * tabIndex
   */
  tabIndex: PropTypes.number,
};

MoveOption.defaultProps = {
  onSelect: undefined,
};
